<template lang="html">
  <div class="agent-detail-cash-history--inner">
    <div class="window-details-toolbar">
      <div class="window-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedType"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="cashin"
            name="cash in"
          >
              <span>cash in</span>
          </select-option>

          <select-option
            value="cashout"
            name="cash out"
          >
              <span>cash out</span>
          </select-option>
        </select-list>
        <select-list
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="confirmed"
            name="confirmed"
          >
            <span>confirmed</span>
          </select-option>

          <select-option
            value="pending"
            name="pending"
          >
            <span>pending</span>
          </select-option>

          <select-option
            value="rejected"
            name="rejected"
          >
            <span>rejected</span>
          </select-option>

          <select-option
            value="waiting"
            name="waiting"
          >
            <span>waiting</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>
          </select-list>
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('id')"
              name="no">
              no
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('created_at')"
              name="request-date">
              request date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('old_balance')"
              name="old_balance">
              before transfer
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('amount')"
              name="amount">
              amount
            </tbl-td>

             <tbl-td
              :sort="true"
              @click.native="sort('new_balance')"
              name="new balance">
              new balance
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('type_id')"
              name="user-ip">
              type id
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('status')"
              name="status">
              status
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('updated_at')"
              name="confirm-date">
              confirm date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('login_id')"
              name="login-id">
              login  id
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('login_name')"
              name="login-name">
              login  name
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('ip')"
              name="user-ip">
              user ip
            </tbl-td>

            <tbl-td name="from">
              from
            </tbl-td>

            <tbl-td name="actions">
              actions
            </tbl-td>
          </tbl-row>
        </tbl-head>

        <tbl-body>
          <tbl-row
            v-for="transfer in transferDetails"
            :key="transfer.id"
          >
            <tbl-td name="no">
              {{transfer.id}}
            </tbl-td>

            <tbl-td name="request-date">
              {{transfer.created_at | date}}
            </tbl-td>

            <tbl-td name="old_balance">
              {{transfer.old_balance | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="amount">
              {{transfer.amount | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="new_balance">
              {{transfer.new_balance | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="user-ip">
              {{transfer.type_id | getCashType}}
            </tbl-td>

            <tbl-td name="status">
              {{transfer.status | status}}
            </tbl-td>

            <tbl-td name="confirm-date">
              {{transfer.updated_at | date}}
            </tbl-td>

            <tbl-td name="login-id">
              {{transfer.user.login_id}}
            </tbl-td>

            <tbl-td name="login-name">
              {{transfer.user.login_name}}
            </tbl-td>

            <tbl-td name="user-ip">
              <span  v-if="transfer.ip">{{transfer.ip}}</span>
              <span  v-else>-</span>
            </tbl-td>

            <tbl-td name="from">
              <span  v-if="transfer.admin">{{transfer.admin.login_id}}</span>
              <span  v-else>-</span>
            </tbl-td>

            <tbl-td name="actions">
              <div
                v-if="(transfer.status.toLowerCase() === 'w' ||
                  transfer.status.toLowerCase() === 'p')"
              >
                <button
                  class="btn--modify"
                  @click="updateStatus(transfer, 'C')"
                >C</button>
                <button
                  class="btn--create"
                  v-if="transfer.status.toLowerCase() !== 'w'"
                  @click="updateStatus(transfer, 'W')"
                >W</button>
                <button
                  class="btn--delete"
                  @click="updateStatus(transfer, 'R')"
                >R</button>
              </div>
              <div v-else>
                -
              </div>
            </tbl-td>
          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="count"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'
//= components
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'
//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'agent-detail-cash-history',

  components: {
    Search,
    CheckDataList,
    Pagination
  },

  mixins: [
    getListStatus,
    swal
  ],

  filters: {
    FormatAmount,
    getCashType (type) {
      if (type === 1 || type === 3) {
        return 'cash in'
      }
      return 'cash out'
    },

    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    }
  },

  created () {
    this.search(this.generate(this.params))
  },

  computed: {
    ...mapState('transfer', ['transferDetails', 'count'])
  },

  data () {
    let params = Object.assign(
      {
        rows: 20,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      selectedList: 'all',
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,
      filterBy: [
        {
          value: 'login_id',
          display: 'login id'
        },

        {
          value: 'login_name',
          display: 'login name'
        },

        {
          value: 'amount',
          display: 'amount'
        },

        {
          value: 'ip',
          display: 'user ip'
        },

        {
          value: 'admins',
          display: 'admin name'
        }
      ],
      dateBy: [
        {
          value: 'created_at',
          display: 'request date'
        },

        {
          value: 'updated_at',
          display: 'confirm date'
        }
      ]
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  methods: {
    ...mapActions('transfer', ['getAgentDetail', 'getAgentDetailCount']),
    ...mapActions('transfer', ['update']),

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
      this.params.rows = 10

      let p = {
        type: this.$route.params.subtype || 'all',
        status: this.selectedStatus || 'all',
        params: this.params,
        uid: this.$route.params.id
      }

      await this.getAgentDetail(p)

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.transferDetails.length) {
        this.isEmpty = true
      }

      this.getAgentDetailCount(p)
    },
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },
    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.params.sort_by = sortBy
      this.search()
    },
    clear () {

    },

    updateStatus (transfer, status) {
      let message = 'Change user to'
      if (status === 'P') {
        message += ` pending?`
      }
      if (status === 'C') {
        message += ` confirmed?`
      }

      if (status === 'W') {
        message += ` waiting?`
      }

      this.$alert('prompt', message, '', (async() => {
        await this.update({
          id: transfer.id,
          status,
          item: transfer
        })

        transfer.updated_at = new Date()

        this.$alert('success', '', '', '', 'Updated')
        transfer.status = status
        this.search()
      }), 'Update')
    }
  }
}
</script>
